console.log("INDEX.TSX: BOOTING APP...");
import './src/index.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { Capacitor } from '@capacitor/core';
import { StatusBar } from '@capacitor/status-bar';

// Al apuntar a targetSdk 36 (Android 16), el sistema fuerza "edge-to-edge"
// (el WebView se dibuja detrás de la barra de hora/batería) y ya no se puede
// desactivar solo con configuración nativa — Google quitó esa opción para
// apps que apuntan a API 35+. En vez de parchar cada pantalla a mano con
// env(safe-area-inset-top), se le pide al plugin StatusBar que reserve ese
// espacio él mismo, restaurando el comportamiento de antes en todas las
// pantallas de una sola vez.
if (Capacitor.isNativePlatform()) {
  StatusBar.setOverlaysWebView({ overlay: false }).catch(() => {});
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("No se pudo encontrar el elemento raíz para montar la aplicación");
}

// Global debug handler for boot issues
window.onerror = (message, source, lineno, colno, error) => {
  const errorMsg = `ERROR EN APP: ${message}\nEn: ${source}:${lineno}`;
  console.error(errorMsg, error);
  // Optional: show on screen if it's a blank screen issue
  setTimeout(() => {
    const loadingEl = document.getElementById('initial-loading');
    if (loadingEl) {
      loadingEl.innerHTML = `<div style="color: red; padding: 20px; text-align: center;">
        <h1 style="margin: 0">Error al iniciar</h1>
        <p style="font-size: 12px">${errorMsg}</p>
        <button onclick="window.location.reload()" style="margin-top: 10px; padding: 10px; background: #333; color: white; border: none; border-radius: 8px;">Reintentar</button>
      </div>`;
    }
  }, 100);
  return false;
};

import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);